var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "finance and payment/outline/bank",
    clipPath: "url(#clip0_978_154)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 579",
    d: "M2.02199 6.66665L13.9781 6.66665C14.6582 6.66665 14.9252 5.7657 14.3594 5.38037L8.76259 1.56915C8.30083 1.2547 7.69925 1.2547 7.23749 1.56915L1.64072 5.38037C1.07486 5.7657 1.34192 6.66665 2.02199 6.66665Z",
    stroke: "#F3FCFA",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 580",
    x: 2.66663,
    y: 6.66669,
    width: 3.33333,
    height: 5.33333,
    stroke: "#F3FCFA",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 581",
    x: 10,
    y: 6.66669,
    width: 3.33333,
    height: 5.33333,
    stroke: "#F3FCFA",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 582",
    d: "M12.7153 12C13.094 12 13.4403 12.214 13.6097 12.5528L13.943 13.2195C14.2755 13.8844 13.792 14.6667 13.0486 14.6667L2.95132 14.6667C2.20794 14.6667 1.72445 13.8844 2.0569 13.2195L2.39023 12.5528C2.55962 12.214 2.90589 12 3.28466 12L12.7153 12Z",
    stroke: "#F3FCFA",
    strokeWidth: 1.5
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_978_154"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.9400dea57241b51d93eb7f93e901fd70.svg";
export { ForwardRef as ReactComponent };